import ComingSoonPage from './ComingSoon';

export default ComingSoonPage;
